// client/src/pages/admin/AdminMassOrders.js
import { Routes, Route, NavLink } from "react-router-dom";
import AdminMassOrderUpload from "./AdminMassOrderUpload";
import AdminMassOrdersList from "./AdminMassOrdersList";

export default function AdminMassOrders() {
  return (
    <div className="space-y-6">
      <div className="flex gap-3">
        <NavLink to="" end className="btn-ghost">Upload</NavLink>
        <NavLink to="status" className="btn-ghost">Order Status</NavLink>
      </div>

      <Routes>
        <Route index element={<AdminMassOrderUpload />} />
        <Route path="status" element={<AdminMassOrdersList />} />
      </Routes>
    </div>
  );
}
  